import React from 'react'
import PropTypes from 'prop-types'
import sockette from 'sockette'
import Logger from '@Common/Utils/Logger'
import config from '@Config'

class WebSocket extends React.Component {
  constructor(props) {
    super(props)
    this.ws = null
    this.onOpen = this.onOpen.bind(this)
    this.onMessage = this.onMessage.bind(this)
    this.onReconnect = this.onReconnect.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onError = this.onError.bind(this)
  }

  shouldComponentUpdate() {
    return false
  }

  componentDidMount() {
    Logger.info('Connecting to socket', this.props.name, config.wsBasePath + this.props.path)
    const socketteConfiguration = {
      maxAttempts: 3,
      onopen: this.onOpen,
      onmessage: this.onMessage,
      onreconnect: this.onReconnect,
      onclose: this.onClose,
      onerror: this.onError,
    }
    this.ws = sockette(
      config.wsBasePath + this.props.path + '?token=' + encodeURIComponent(this.props.token),
      socketteConfiguration,
    )
  }

  componentWillUnmount() {
    if (this.ws.readyState !== 1) {
      this.ws.closedBeforeConnection = true
    }
    this.ws.close()
  }

  onOpen(ev) {
    Logger.info('Socket connected!', this.props.name, ev)
  }

  onError(ev) {
    if (this.ws.closedBeforeConnection) {
      Logger.info('Socket closed before connection, ignoring connection error', this.props.name, ev)
    } else {
      Logger.error('Socket error', this.props.name, ev)
      this.props.onError(ev)
    }
  }

  onMessage(ev) {
    Logger.debug('Socket received json', this.props.name, JSON.parse(ev.data))
    this.props.onMessage(JSON.parse(ev.data)) // text socket
  }

  onReconnect(ev) {
    Logger.info('Socket reconnecting', this.props.name, ev)
  }

  onClose(ev) {
    Logger.info('Socket closing', this.props.name, ev)
  }

  sendMessage(text) {
    Logger.debug('Socket sending message', this.props.name, text)
    this.ws.send(text)
  }

  render() {
    return null
  }
}

WebSocket.propTypes = {
  token: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onMessage: PropTypes.func.isRequired,
}

export default WebSocket
